import { ItemScheme } from '../../../Components/Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';

export default function useDynamicWizard() {
	const validateWizardScheme = (scheme: ItemScheme[]) => {
		const validatedScheme: ItemScheme[] = [];
		scheme.forEach(item => {
			const children = item.children;
			delete item.children;
			if (item.type === MagicField.TEXTAREA && !item.key) {
				return;
			}
			validatedScheme.push({
				...item,
				children: validateWizardScheme(children as ItemScheme[]),
			} as ItemScheme);
		});
		return validatedScheme;
	};

	const generateDefaultValues = (scheme: ItemScheme[]) => {
		let defaultValues: Record<string, any> = {};
		scheme.forEach(item => {
			if (item.value && item.type) {
				if (item.key) {
					defaultValues[item.key] = item.value;
				}
			}
			if (!item.value && (item.children?.length || 0) > 0) {
				if (item.key) {
					defaultValues[item.key] = generateDefaultValues(
						item.children as ItemScheme[],
					);
				} else {
					defaultValues = {
						...defaultValues,
						...generateDefaultValues(item.children as ItemScheme[]),
					};
				}
			}
		});
		return defaultValues;
	};

	const prepareScheme = (scheme: any[], parentType?: string): ItemScheme[] => {
		const formScheme: ItemScheme[] = [];
		scheme.forEach(item => {
			const newItem = {
				key: item.key || item.value,
				value: item.value,
				title: item.title,
				type: handleType(item.type, parentType),
				settings: item.settings || undefined,
				children:
					(item.children?.length || 0) > 0
						? prepareScheme(item.children, item.type)
						: undefined,
			};
			formScheme.push(removeNullUndefined(newItem) as ItemScheme);
		});
		return formScheme;
	};

	const handleType = (type: string, parentType?: string) => {
		if (parentType === 'select') {
			return undefined;
		}
		return type;
	};

	const removeNullUndefined = (obj: Record<string, any>) => {
		for (const key in obj) {
			if (obj[key] === null || obj[key] === undefined) {
				delete obj[key];
			}
		}
		return obj;
	};

	return {
		validateWizardScheme,
		generateDefaultValues,
		prepareScheme,
	};
}
